// extracted by mini-css-extract-plugin
export default {"imageContainer":"_1-z","summaryPar":"a2-z","ratingCategories":"b2-z","reviewerInfo":"c2-z","reviewTypes":"d2-z","expanded":"e2-z"};